
import axios from 'axios'

type FetchOptionsT = {
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
  body?: any,
}

export default async function fetchFrom (endpoint: string, options?: FetchOptionsT): Promise<any> {

  let baseUrl = 'https://api-dev.icapronto.se';

  if (import.meta.env.VITE_ENV === 'stage') {
    baseUrl = 'https://api-staging.icapronto.se';
  } else if (import.meta.env.VITE_ENV=== 'production') {
    baseUrl = 'https://api.icapronto.se';
  }

  const requestUrl = baseUrl + endpoint
  const headers = {
    "Cache-Control": "no-cache",
    'x-client-name': 'icakiosk',
  }
  if (options?.method === 'POST') {
    try {
      const { status, data } = await axios.post(requestUrl, options.body, {
        headers,
      })
      if (status === 200) {
        return data
      }
    } catch (error: any) {
      const e = error ? error : 'Something went wrong while posting data'
      return new Error(e)
    }
  } else if (options?.method === 'PUT') {
    try {
      const { status, data } = await axios.put(requestUrl, options.body, {
        headers,
      })

      if (status === 200) {
        return data
      }
    } catch (error: any) {
      const e = error ? error : 'Something went wrong while updating data'
      return new Error(e)
    }
  } else if (options?.method === 'PATCH') {
    try {
      const { status, data } = await axios.patch(requestUrl, options.body, {
        headers,
      })
      if (status === 200) {
        return data
      }
    } catch (error: any) {
      const e = error ? error : 'Something went wrong while updating data'
      return new Error(e)
    }
  } else if (options?.method === 'DELETE') {
    try {
      const { status, data } = await axios.delete(requestUrl, {
        headers,
      })
      if (status === 200) {
        return data
      }
    } catch (error: any) {
      const e = error ? error : 'Something went wrong while updating data'
      return new Error(e)
    }
  } else {
    try {
      const { status, data } = await axios.get(requestUrl, {
        headers,
      })
      if (status === 200) {
        return data
      }
    } catch (error: any) {
      const e = error ? error : 'Something went wrong while fetching data'
      return new Error(e)
    }
  }

}
export { fetchFrom } 